require('../scss/home/style.scss');

import { EntryHome } from "./project/EntryHome";

namespace home {
    const entry: EntryHome = new EntryHome();
    entry.run()
}






